import React from "react";
import styled from 'styled-components';



const TitleText = styled.h1`
  font-size: 20px;
  font-weight: 400;

  & > span {
 
    font-weight: 600; 
  }

  z-index: 200;

  
`;
export default TitleText;